module.exports = __webpack_public_path__ + "static/img/EMMCr-B5rWE7Y1.92042fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/EMMCr-B5rWE7Y1.png
// module id = biV7
// module chunks = 16